module.exports = __webpack_public_path__ + "assets/static/img/phone.e783e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.png
// module id = 96
// module chunks = 1